export default function CheckIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
      <path d="m9 21.035-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436L24 5.782z" />
    </svg>
  );
}
